import { useCallback, useEffect, useRef, useState } from 'react'
import hipersendService from '../../services/hipersend'

// Conferência ao vivo do disparo: custo, saldo e o que impede o envio, vindos
// do master. Espera a pessoa parar de mexer (600 ms) antes de perguntar, e só
// a resposta da pergunta MAIS NOVA vale — uma lenta que chega depois não pode
// trocar o resumo por um que já não vale.

const ESPERA_MS = 600

function mensagemDoErro(e) {
  return e?.response?.data?.message || 'Não foi possível conferir o disparo agora'
}

export default function useConferenciaDoDisparo({ api, secret, destinatarios, conteudo, limitarA }) {
  const [conferencia, setConferencia] = useState(null)
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro] = useState('')
  const [rodada, setRodada] = useState(0)
  const ultima = useRef(0)
  // Confere de novo sem a entrada mudar — ex.: a pessoa voltou da recarga.
  const atualizar = useCallback(() => setRodada((r) => r + 1), [])

  // A lista chega como array novo a cada render; a chave é o conteúdo.
  const chave = JSON.stringify({ destinatarios, conteudo, limitarA })

  useEffect(() => {
    if (!api || !secret || !destinatarios || !destinatarios.length) {
      ultima.current += 1
      setConferencia(null)
      setCarregando(false)
      return undefined
    }

    const espera = setTimeout(() => {
      const minha = ++ultima.current
      setCarregando(true)
      hipersendService.disparos
        .conferir(api, secret, { destinatarios, conteudo, limitarA })
        .then((resposta) => {
          if (minha !== ultima.current) return
          setConferencia(resposta)
          setErro('')
        })
        .catch((e) => {
          if (minha !== ultima.current) return
          setErro(mensagemDoErro(e))
        })
        .finally(() => {
          if (minha === ultima.current) setCarregando(false)
        })
    }, ESPERA_MS)

    return () => clearTimeout(espera)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, secret, chave, rodada])

  return { conferencia, carregando, erro, atualizar }
}
